interface ApiFunctionArgs {
  url: string;
  query?: Record<string, unknown>;
  body?: unknown;
  headers?: Record<string, string>;
  imageFile?: string | Blob | undefined;
}

export const apiGet = async ({ url, headers }: ApiFunctionArgs) => {
  const baseUrl = "https://feedback-gateway.switchcase.dev";
  const setUrl = baseUrl + url;

  return $fetch(setUrl, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      ...headers,
    },
  });
};

export const apiPost = async ({ url, body, headers }: ApiFunctionArgs) => {
  const baseUrl = "https://feedback-gateway.switchcase.dev";
  const setUrl = baseUrl + url;
  return $fetch(setUrl, {
    method: "POST",
    headers: {
      ...headers,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(body),
  });
};
